import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';
import { UserMaster } from '../../models/user-master/user-master';

@Injectable({
  providedIn: 'root',
})
export class SearchUserMasterService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.userMasterApi + '/api/v1/user';

  getUserByUserName(userName: string): Observable<ApiResponse<UserMaster>> {
    return this.httpClient.get<ApiResponse<UserMaster>>(`${this.baseUrl}/username/${encodeURIComponent(userName)}`);
  }
}
